import React from 'react'
import scrollableImg1 from '../../assets/images/features/dynamic-conversations.webp'
import scrollableImg2 from '../../assets/images/features/any-device.webp'
import scrollableImg3 from '../../assets/images/features/android-wear-apple.webp'
import scrollableImg4 from '../../assets/images/features/Android-Apple-Watch.webp'
import Loadable from '@loadable/component'
const OwlCarousel = Loadable(() => import('react-owl-carousel3'))

const options = {
    loop: true,
    nav: false,
    dots: true,
    autoplayHoverPause: true,
    autoplay: true,
    items: 1,
    navText: [
        "<i class='flaticon-left-1'></i>",
        "<i class='flaticon-right-1'></i>"
    ]
};

const CaseStudySlider = () => {
    const [display, setDisplay] = React.useState(false);

    React.useEffect(() => {
        setDisplay(true);
    }, [])

    return (
        <div className="container case-study-area" style={{margin: 'auto'}}>
            {display ? <OwlCarousel 
                className="case-study-slides owl-carousel owl-theme"
                {...options}
            > 
                <div className="container single-case-study-item">
                    <img src={scrollableImg4} alt="scrollableImg" />
                    <div className="container">
                        <div className="case-study-content">
                            <div>
                            <h2>Android Wear & Apple Watch</h2>
                            <p>Intelligent email on your wrist and any other wearable devices</p>
                            </div>
                            {/* <Link to="/case-studies-details" className="default-btn-white">
                                Learn More <span></span>
                            </Link> */}
                        </div>
                    </div>
                </div>
               
                
               
                
            </OwlCarousel> : ''}
        </div>
    )
}

export default CaseStudySlider